import React from "react";
import {Grid, withStyles} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import CustomSelect from "../../components/Select";
import IdFilter from "../../components/Filters/IdFilter";
import {connect} from "react-redux";
import MuiPickersUtilsProvider from "@material-ui/pickers/MuiPickersUtilsProvider";
import DateFnsUtils from "@date-io/date-fns";
import ruLocale from "date-fns/locale/ru";
import {DatePicker} from "@material-ui/pickers";
import {ThemeProvider} from "@material-ui/styles";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";

const Theme = (borderRadius = "20px 20px") => createMuiTheme({
    overrides: {
        MuiOutlinedInput: {
            root: {
                borderRadius: borderRadius,
            },
            input: {
                padding: '10.5px 14px',
            }
        },
        MuiFormLabel: {
            root: {
                lineHeight: 0
            }
        }
    },
    palette: {
        primary: {
            main: '#95c61c'
        },

        secondary: {
            main: '#95c61c',
            light: '#b2d164'
        },
    },
});

class Filters extends React.Component
{
    render() {

        const {filterBy, sites, users, filters} = this.props;
        let maxdate = new Date();
        maxdate.setHours(maxdate.getHours() - maxdate.getTimezoneOffset() / 60);

        return (
            <Grid container alignItems={'stretch'} direction={'row'} justify={'wrap'}>
                <Grid item xs={3} lg={3} md={3} sm={3}>
                    <Typography
                        component={'div'}
                        style={{marginBottom: '30px', fontSize: '2rem'}}
                    >
                        История расходов
                    </Typography>
                </Grid>
                <Grid item xs={1.5} lg={1.5} md={1.5} sm={1.5}>
                    <ThemeProvider theme={Theme('20px 0 0 20px')}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ruLocale}>
                            <DatePicker
                                disableToolbar
                                variant="inline"
                                inputVariant={'outlined'}
                                label="Дата с:"
                                value={filters.dateFrom}
                                onChange={(val) => filterBy(val, 'dateFrom')}
                                maxDate={filters.dateTo}
                            />
                        </MuiPickersUtilsProvider>
                    </ThemeProvider>
                </Grid>
                <Grid item xs={1.5} lg={1.5} md={1.5} sm={1.5}>
                    <ThemeProvider theme={Theme('0 20px 20px 0')}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ruLocale}>
                            <DatePicker
                                disableToolbar
                                variant="inline"
                                inputVariant={'outlined'}
                                label="Дата по:"
                                value={filters.dateTo}
                                onChange={(val) => filterBy(val, 'dateTo')}
                                minDate={filters.dateFrom}
                                maxDate={maxdate}
                            />
                        </MuiPickersUtilsProvider>
                    </ThemeProvider>
                </Grid>
                <Grid item xs={1} lg={1} md={1} sm={1}>
                </Grid>
                <Grid item xs={1.5} lg={1.5} md={1.5} sm={1.5}>
                    <IdFilter value={filters.login} onInput={(e) => {filterBy(e.target.value, 'login')}}/>
                </Grid>
                <Grid item xs={1.5} lg={1.5} md={1.5} sm={1.5}>
                    <IdFilter value={filters.name} borderRadius={'0 0 0 0'} label={'Имя'} onInput={(e) => {filterBy(e.target.value, 'name')}}/>
                </Grid>
                <Grid item xs={1.5} lg={1.5} md={1.5} sm={1.5}>
                    <CustomSelect
                        onChange={(val) => filterBy(val, 'site')}
                        name={'site'}
                        rowsPerPageOptions={sites}
                        withLabel={true}
                        emptyName={'Все сайты'}
                        withEmpty
                        borderRadius={'0 20px 20px 0'}
                        label={'Сайт'}
                        width={'170px'}
                        type={'autocomplete'}
                    />
                </Grid>

            </Grid>
        );
    }
}

const mapStateToProps = store => {
    return {
        sites: store.Clients.sites,
        users: store.Clients.users
    }
}

export default connect(mapStateToProps)(Filters)